module.exports = __webpack_public_path__ + "static/media/Monique.03d3c549.jpeg";